import { MdClose } from "react-icons/md";

import Modal from "../Utilities/Modal";

import baseStyles from "../EventManagement/style/EventFormPage.module.scss";
import styles from "./style/WebsiteAnnouncementPreviewModal.module.scss";
import { stripHtmlToPlain } from "./releaseNotesTransforms";
import { normalizeDisplayTypeFromApi } from "./systemAnnouncementsTransforms";

const WebsiteAnnouncementPreviewModal = ({
  isOpen,
  onClose,
  title,
  contentHtml = "",
  displayType: displayTypeRaw,
  redirectButtonText = "",
  redirectUrl = "",
}) => {
  const variant = normalizeDisplayTypeFromApi(displayTypeRaw);
  const titleStr = String(title || "").trim() || "未命名公告";
  const plainBody = stripHtmlToPlain(contentHtml);
  const hasHtml = Boolean(String(contentHtml || "").trim());
  const ctaLabel = String(redirectButtonText || "").trim();
  const ctaUrl = String(redirectUrl || "").trim();
  const hasCta = Boolean(ctaLabel && ctaUrl);

  const renderBanner = () => (
    <div className={styles.bannerBar}>
      <div className={styles.bannerContent}>
        <span className={styles.bannerText}>
          {titleStr}：{plainBody || "（尚無內文）"}
        </span>
        {hasCta ? (
          <span className={styles.bannerLinkText}>{ctaLabel}</span>
        ) : null}
      </div>
    </div>
  );

  const renderOverlayCard = (asPopover) => {
    const closeBtnClass = asPopover ? styles.btnCloseLight : styles.btnClose;
    const inner = (
      <>
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>{titleStr}</h3>
          <span className={styles.cardDismiss} aria-hidden>
            <MdClose size={20} />
          </span>
        </div>
        {hasHtml ? (
          <div
            className={styles.cardRichText}
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          />
        ) : (
          <p className={styles.cardPlaceholder}>尚無公告內容</p>
        )}
        <div className={styles.fakeCheckboxRow}>
          <span className={styles.fakeCheckbox} aria-hidden />
          <span>今日不再顯示</span>
        </div>
        <div className={styles.cardActions}>
          <button type='button' className={closeBtnClass} tabIndex={-1}>
            關閉
          </button>
          {hasCta ? (
            <button type='button' className={styles.btnCta} tabIndex={-1}>
              {ctaLabel}
            </button>
          ) : null}
        </div>
      </>
    );

    if (asPopover) {
      return (
        <div className={styles.popoverCard}>
          <div className={styles.popoverCardInner}>{inner}</div>
        </div>
      );
    }

    return <div className={styles.fullscreenCard}>{inner}</div>;
  };

  const renderBody = () => {
    if (variant === "banner") {
      return <div className={styles.previewStage}>{renderBanner()}</div>;
    }

    if (variant === "popover") {
      return (
        <div className={`${styles.previewStage} ${styles.popoverStage}`}>
          {renderOverlayCard(true)}
        </div>
      );
    }

    return (
      <div className={`${styles.previewStage} ${styles.fullscreenStage}`}>
        {renderOverlayCard(false)}
      </div>
    );
  };

  return (
    <Modal isOpen={isOpen} size='xl' width={"fit-content"}>
      <div
        className={`${baseStyles.previewModalRoot} ${styles.previewModalFit}`}
      >
        <header className={baseStyles.previewModalHeader}>
          <h2 className={baseStyles.previewModalTitle}>預覽</h2>
        </header>

        <div className={baseStyles.previewModalBody}>{renderBody()}</div>

        <footer className={baseStyles.previewModalFooter}>
          <button
            type='button'
            className={baseStyles.previewModalCloseButton}
            onClick={onClose}
          >
            關閉
          </button>
        </footer>
      </div>
    </Modal>
  );
};

export default WebsiteAnnouncementPreviewModal;
